import * as React from "react";
import { memo } from "react";
import { styled } from "@mui/material";
import { MobileView } from "../../../util/aKaunGeneralUtil";

import { makeStyles, withStyles } from "@mui/styles";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import clsx from "clsx";
import Check from "@mui/icons-material/Check";
import StepConnector from "@mui/material/StepConnector";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import { RosebudRouteSetting } from "../util/rosebudRoutesSettings";
import { useRouteHelper } from "../useRouteHelper";

//region [[ Styles ]]

export const SantanaMobileStepperHeight = 110;

const SantanaStepperView = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  [theme.breakpoints.up(MobileView)]: {
    "& i": {
      marginLeft: "5px",
    },
    "& i:first-child": {
      marginLeft: "0",
    },
  },
  [theme.breakpoints.down(MobileView)]: {
    "& i": {
      marginLeft: "0px",
    },
    "& i:first-child": {
      marginLeft: "0",
    },
    backgroundColor: "white",
  },
}));

const StepperStyled = styled(Stepper)(({ theme }) => ({
  paddingLeft: "0px",
  paddingTop: "12px",

  [theme.breakpoints.down(MobileView)]: {
    paddingLeft: "0px",
    paddingTop: "15px",
    marginLeft: "-20px",
    marginRight: "-20px",
  },

  paddingRight: "0px",
  "& .Mui-disabled": {
    backgroundColor: "unset !important",
  },
}));

const CheckStyled = styled(Check)(({ theme }) => ({
  color: "white",
  backgroundColor: KahunColorMap.PrimaryDim,
  borderRadius: "50%",
}));

const StepNumber = styled("div")(
  ({ indent }: { indent: "true" | "false" }) => ({
    color: "white !important",
    marginLeft: indent === "true" ? "8px" : "6px",
    marginTop: "1px",
  }),
);

const StepCircle = styled("div")(({ theme }) => ({
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
}));

const SantanaStepperItem = styled("i")(({ theme }) => ({
  height: "20px",
  marginBottom: "20px",

  [theme.breakpoints.down(MobileView)]: {
    height: "0px",
    marginBottom: "0px",
  },

  margin: "48%, 0",
  background: "white",
  transition: "width 500ms ease-in",
  width: 0,
}));

const QontoConnector = withStyles({
  root: {
    width: "100%",
  },
  alternativeLabel: {
    top: 10,
    left: "calc(-50% + 0px)",
    right: "calc(50% + 0px)",
  },
  active: {
    "& $line": {
      borderColor: KahunColorMap.PrimaryDim,
    },
  },
  completed: {
    "& $line": {
      borderColor: KahunColorMap.PrimaryDim,
    },
  },
  line: {
    borderColor: "#c4c4c4",
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector);

const useQontoStepIconStyles = makeStyles({
  root: {
    color: "#eaeaf0",
    display: "flex",
    height: 22,
    alignItems: "center",
  },
  active: {
    color: KahunColorMap.PrimaryDim,
    "& div": {
      color: KahunColorMap.PrimaryDim,
      zIndex: 1,
      width: 22,
      height: 22,
    },
  },
  circle: {
    width: 12,
    height: 12,
    borderRadius: "50%",
    color: "#c4c4c4",
    backgroundColor: "currentColor",
  },
  completed: {
    width: 12,
    height: 12,
    color: "white",
    zIndex: 1,
    fontSize: 18,
  },
});

function QontoStepIcon(props: any) {
  const classes = useQontoStepIconStyles();
  const { active, completed, icon } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? (
        <CheckStyled className={classes.completed} />
      ) : (
        <StepCircle className={classes.circle}>
          {active && (
            <StepNumber indent={icon === 1 ? "true" : "false"}>
              {icon}
            </StepNumber>
          )}
        </StepCircle>
      )}
    </div>
  );
}

//endregion [[ Styles ]]

//region [[ Props ]]

export interface SantanaStepperProps {
  className?: string;
  current: number;
  steps: RosebudRouteSetting[];
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

const useWidth = makeStyles({
  stepperWidth: ({ width }: { width: number }) => ({
    width: `${width}%`,
    transition: "width 600ms ease-in",
  }),
});

export const SantanaStepper = memo(
  ({ current, steps, ...props }: SantanaStepperProps) => {
    const { stepperWidth } = useWidth({
      width: Math.round((100 / steps.length) * current),
    });

    const { navigateTo } = useRouteHelper();

    const wizardSteps = [...Array(steps.length).keys()];

    const onClickStep = (index: number) => {
      navigateTo({ step: steps[index] });
    };

    return (
      <>
        <SantanaStepperView className={props.className}>
          <StepperStyled
            alternativeLabel
            activeStep={current}
            connector={<QontoConnector />}
          >
            {wizardSteps.map((step, index) => (
              <Step
                key={index}
                onClick={() => onClickStep(index)}
                style={{ cursor: "pointer" }}
              >
                <StepLabel StepIconComponent={QontoStepIcon}></StepLabel>
              </Step>
            ))}
          </StepperStyled>
          <SantanaStepperItem className={stepperWidth} />
        </SantanaStepperView>
      </>
    );
  },
);
